// extracted by mini-css-extract-plugin
export default {"Error404":"NotFound_Error404__PEnYH","Error404-content":"NotFound_Error404-content__QK-vB"};